import styled from 'styled-components';
import { Button } from 'Shared/Button';
import { mediaBreakpointDown } from 'Shared/Utility';

export const statValueStyles = {
  fontSize: 'xl',
  fontWeight: 'normal',
  color: 'gray.700',
  letterSpacing: 'tight',
  m: 0,
};

export const SurveyResults = styled.div``;
export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
`;
export const HeaderLeft = styled.div`
  display: flex;
  align-items: flex-start;
  ${mediaBreakpointDown('md')} {
    flex-basis: 100%;
    margin-bottom: 10px;
  }
`;
export const Metric = styled.div`
  display: inline-block;
  margin: 0 1px;
  padding: 7px 20px 7px 0;
  font-weight: 500;
  font-size: 14px;
  color: #888;

  margin-right: 25px;

  :last-child {
    margin-right: 0;
  }
`;
export const HeaderRight = styled.div`
  display: flex;

  ${mediaBreakpointDown('md')} {
    flex-basis: 100%;
    justify-content: center;
    margin-top: 20px;
  }
`;

export const ActionButton = styled(Button)`
  > i {
    margin-right: 8px;
  }
  :last-child {
    margin-left: 4px;
  }
`;
export const Body = styled.div``;

export const Feasibility = styled.div`
  display: block;
  font-weight: 500;
  padding: 8px;
  background: ${(props) => (props.feasible ? '#DED' : '#EBB')};
  margin: 0 auto;
  border-radius: 3px;
  text-align: center;
`;

export const Panel = styled.div`
  border-radius: 8px;
  background: #fff;
  margin: 30px 0;
  padding: 50px;
  text-align: center;
  box-shadow: #e1e2e5 0 0 21px -3px;
  > h4 {
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 20px;
  }
`;
